/**
 * Vertriebsgebiet Validation API Service
 * Validates user input via backend LLM and returns suggestions
 */

import { apiClient } from './client';

export interface VertriebsgebietValidationResponse {
  suggestions: string[];
}

export const vertriebsgebietService = {
  /**
   * Validate a Vertriebsgebiet input via backend LLM
   * Returns a list of matching suggestions the user can choose from
   */
  async validate(input: string): Promise<VertriebsgebietValidationResponse> {
    return apiClient.post<VertriebsgebietValidationResponse>(
      '/api/Vertriebsgebiet/validate',
      { input }
    );
  },
};
